let showMoreServicesButton = document.querySelectorAll('.block_content_services .show-more-services');

showMoreServicesButton.forEach(function (el) {
    el.addEventListener('click', function () {
        this.parentElement.classList.add('hide');
        this.parentElement.parentElement.parentElement.classList.add('show-items');
    });
});
